import { combineReducers } from "@reduxjs/toolkit";
import UserSlice from "./userSlice";

const Slices = combineReducers({
  User: UserSlice.reducer,
});
export default Slices;
